<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add product</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New product parameters by {{ set.item }} set
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="trademark" 
                                    v-model="trademark" name="trademark"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" label="model"
                                    v-model="model" name="model"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" 
                                    label="material level quality"
                                    v-model.number="material"
                                    name="material" type="text" 
                                    :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" 
                                    label="manufacturing level quality"
                                    v-model.number="manufacturing"
                                    name="manufacturing" type="text"
                                    :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" 
                                    label="design level quality"
                                    v-model.number="design"
                                    name="design" type="text"
                                    :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary" label="type of design"
                                    v-model="design_type" 
                                    :items="types"
                                    :rules="[rules.required]"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field dense color="primary" 
                                    label="variations of model"
                                    v-model.number="variations"
                                    name="variations" type="text"
                                    :rules="[rules.required, rules.number, rules.max]"
                                    @change="onceMore()">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <v-select dense color="primary"
                                    return-object
                                    label="advanced feature"
                                    clearable
                                    v-model="advanced_feature" 
                                    :items="features"
                                    item-text="text"
                                    item-value="value"
                                    @change="onceMore()">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" 
                                        label="sales plan"
                                        v-model.number="sales_plan"
                                        name="sales_plan" type="text" 
                                        :rules="[rules.required, rules.number]"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" 
                                        label="production plan"
                                        v-model.number="production_plan"
                                        name="production_plan" type="text"
                                        :rules="[rules.required, rules.number]"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" 
                                        label="ex-works price"
                                        v-model.number="price"
                                        name="price" type="text"
                                        :rules="[rules.required, rules.number]"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-text-field dense color="primary" 
                                        label="retail price"
                                        v-model.number="retail_price"
                                        name="retail_price" type="text"
                                        :rules="[rules.required, rules.number]"
                                        @change="onceMore()">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-select dense color="primary"
                                        return-object
                                        label="team"
                                        v-model.number="team" 
                                        :items="teams"
                                        item-text="name"
                                        item-value="id"
                                        @change="onceMore()">
                                    </v-select>
                                </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
                <v-row justify="center" class="subtitle-2">{{ message }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="calculating">
                    Calculate
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!calculate || Boolean(error)"
                    @click="addProduct">
                    Save
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { UnitCost } from '../../../functions/product';

export default {
    name: 'AddProduct',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number',
                max: v => v <= 5 || 'max 5 expected',
            },
            types: ['classic', 'business', 'casual', 'innovative', 'art'],
            features: [
                {text: 'positioning tracker', value: 1},
                {text: 'power bank', value: 2},
                {text: 'missed items warning', value: 3},
                {text: 'danger alarm', value: 4},
                {text: 'fridge camera', value: 5},
                {text: 'individual pictures', value: 6},
                {text: 'against loss insurance', value: 7},
                {text: 'environment friendly utilization', value: 8},
                {text: 'charity profit sharing', value: 9}
            ],
            calculate: false,
            game_id: this.set.value,
            trademark: '',
            model: '',
            available_from: 1, //month
            available_till: 12,
            material: 1,
            manufacturing: 1,
            design_type: '', //enum
            design: 1,
            variations: 1,
            advanced_feature: null, //enum
            sales_plan: 0,
            production_plan: 0,
            retail_price: 0,
            price: 0,

            team: {}, //foring-key

            investments: 0,
            unit_cost: 0,
            
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        teams() {
            return this.$store.getters.teams;
        }
    },
    watch: {
        async set() {
            //console.log('set: ', this.set)
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
    },
    methods: {
        onceMore() {
            this.error = '';
            this.calculate = false;
            this.message = '';
        },
        generatorId(num) {
            return '_' + Math.random().toString(36).substr(2, num);
        },
        calculating() {
          if (this.$refs.form.validate()) {
        
            if (!this.advanced_feature) {
                this.unit_cost = UnitCost(this.material, this.manufacturing, this.variations)
                //this.investments = Investments(this.material, this.manufacturing, this.variations, this.design)
            }
            else {
               this.unit_cost = UnitCost(
                this.material,
                this.manufacturing,
                this.variations,
                this.advanced_feature.value);
            }
            
            this.message = `unit cost = ${this.unit_cost}`
            this.calculate = true;
          }  
        },
        async addProduct() {

            if (this.$refs.form.validate()) {

                let af = '';
                if (this.advanced_feature) {
                    af = this.advanced_feature.text;
                }

                const id = this.generatorId(9);
                const prod = {
                    gameId: this.set.value,
                    round: this.round,
                    productId: id,
                    trademark: this.trademark,
                    model: this.model,
                    available_from: this.available_from,
                    available_till: this.available_till,
                    material: this.material,
                    manufacturing: this.manufacturing,
                    design_type: this.design_type, 
                    design: this.design,
                    variations: this.variations,
                    advanced_feature: af, 
                    sales_plan: this.sales_plan,
                    production_plan: this.production_plan,
                    retail_price: this.retail_price,
                    price: this.price,

                    teamId: this.team.id,
                    team: this.team,
                    investments: this.investments,
                    unit_cost: this.unit_cost,
                }
                console.log(prod)
                try {
                    //add product
                    await this.$store.dispatch('addProduct', prod)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.name = '';
            this.calculate = false;
            this.$refs.form.reset();
        }
    },
    async mounted() {
        if (this.teams.length < 1) {
            try {   
                await this.$store.dispatch('fetchTeams', this.set.value);           
            }
            catch (err) {
                console.log(err)
            }
        }
    }
}
</script>